<template>
  <picture>
    <source type="image/avif" :srcset="img.avif" :sizes="sizes" />
    <img
      :srcset="img.fallback"
      :sizes="sizes"
      :width="img.width"
      :height="img.height"
      :alt="alt"
      :class="imgClass"
      :loading="loading"
      :fetchpriority="fetchpriority"
    />
  </picture>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';
import { computed } from 'vue';
import { getImage } from '@/scripts/images';

/// Setup
const props = defineProps({
  name: { type: String, required: true },
  alt: { type: String, required: true },
  sizes: { type: String, required: true },
  eager: { type: Boolean, default: false },
  preload: { type: Boolean, default: false },
  imgClass: { type: String, default: '' },
});

/// Computed
const img = computed(() => getImage(props.name));
const loading = computed(() => (props.eager ? 'eager' : 'lazy'));
const fetchpriority = computed(() => (props.eager ? 'high' : 'auto'));
// Explicit AVIF preload for the LCP image. On pre-rendered pages qssg bakes this into the
// static <head>, so the browser discovers it at parse — ahead of the <picture> in the body — which
// front-runs the banner fetch and removes the cold-load flicker. Empty otherwise (composables can't
// be called conditionally, so the link list is toggled instead).
useHead({
  link: computed(() =>
    props.preload
      ? [
          {
            rel: 'preload',
            as: 'image',
            type: 'image/avif',
            imagesrcset: img.value.avif,
            imagesizes: props.sizes,
            fetchpriority: 'high',
          },
        ]
      : [],
  ),
});
</script>
